export const generateShareLinks = (idResult) => {
    const currentUrl = `${window.location.origin}/jsonviewer/${idResult}`;
    return {
        "current": currentUrl,
        "facebook": `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
        "whatsapp": `https://api.whatsapp.com/send/?text=${currentUrl}`,
        "linkedin": `https://www.linkedin.com/shareArticle?url=${currentUrl}}`
    }
}
